import React, { useEffect, useState } from 'react';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import MUIDataTable from 'mui-datatables';
import { gql, useQuery } from '@apollo/client';

import LockAlertIcon from '../icons/LockAlertIcon.jsx';
import LockClockIcon from '../icons/LockClockIcon.jsx';
import LockIcon from '../icons/LockIcon.jsx';
import LockOpenIcon from '../icons/LockOpenIcon.jsx';
import DoorControl from '../components/DoorControl.jsx';

const useStyles = makeStyles((theme) => ({
  doorcontrol: {
    padding: theme.spacing(1),
  },
  dataTableActions: {
    '& span': {
      paddingLeft: '0px',
      paddingRight: '7px',
      '& svg': {
        verticalAlign: 'bottom',
      },
    },
  },
  dataTable: {
    width: '100%',
    '& thead': {
      display: 'none',
    },
    '& td': {
      padding: '5px',
      borderBottom: 'none !important',
      '& p': {
        fontSize: '0.8rem',
      },
    },
  },
  iconSize: {
    width: '18px',
    height: '18px',
  },
  threedotsicon: {
    zIndex: '99',
  },
}));

const FETCH_DOORS = gql`
  query doors {
    doors {
      totalCount
      edges {
        acrId
        name
        doorType
        doorSubType
      }
    }
  }
`;

const DoorControlWidget = () => {
  const queryError = ({ graphQLErrors, networkError }) => {};

  const [mrdDoors, setMrdDoors] = useState([]);

  const queryMrdDoorsCompleted = (data) => {
    setMrdDoors(data.doors.edges);
  };

  const { loading: loadingMrdDoors, ERROR: errorMrdDoors } = useQuery(FETCH_DOORS, {
    notifyOnNetworkStatusChange: true,
    onCompleted: queryMrdDoorsCompleted,
    onError: queryError,
    fetchPolicy: 'no-cache',
  });

  const classes = useStyles();
  const columns = ['Door', 'State', 'Actions'];
  const [isExpandable, setIsExpandable] = useState(false);
  const tableOptions = {
    filter: false,
    print: false,
    search: false,
    download: false,
    viewColumns: false,
    selectableRowsOnClick: false,
    elevation: 0,
    pagination: false,
    responsive: 'standard',
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
  };

  const formattedControlData = () => {
    return mrdDoors.map((item) => {
      let actions;
      if (item.doorType === 'engage') {
        if (item.doorSubType === 'nde' || item.doorSubType === 'le') {
          actions = (
            <div className={classes.dataTableActions}>
              <span>
                <LockIcon className={classes.iconSize} style={{ color: '#616161' }} />
              </span>
              <span>
                <LockOpenIcon className={classes.iconSize} style={{ color: '#388e3c' }} />
              </span>
              <span>
                <LockClockIcon className={classes.iconSize} color="secondary" />
              </span>
            </div>
          );
        } else {
          actions = (
            <div className={classes.dataTableActions}>
              <span>
                <LockClockIcon className={classes.iconSize} color="secondary" />
              </span>
            </div>
          );
        }
      } else {
        actions = (
          <div className={classes.dataTableActions}>
            <span>
              <LockIcon className={classes.iconSize} style={{ color: '#616161' }} />
            </span>
            <span>
              <LockOpenIcon className={classes.iconSize} style={{ color: '#388e3c' }} />
            </span>
            <span>
              <LockAlertIcon className={classes.iconSize} style={{ color: '#f9a825 ' }} />
            </span>
            <span>
              <LockClockIcon className={classes.iconSize} color="secondary" />
            </span>
          </div>
        );
      }

      const doorState = [];

      const doorName = (
        <Typography color={item.state === 'Open' ? 'error' : 'initial'}>{item.name}</Typography>
      );
      return [doorName, doorState, actions];
    });
  };
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }
  const prevOpen = React.useRef(open);
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = open;
  }, [open]);

  return (
    <>
      <Paper elevation={3} className={classes.doorcontrol}>
        <Grid container spacing={3}>
          <Grid item xs={10}>
            <Typography style={{ fontWeight: 600 }} variant="body1">
              Door Group
            </Typography>
            <Typography variant="subtitle2">Door Group Main</Typography>
          </Grid>
          <Grid item xs={2}>
            <div style={{ marginTop: '18%' }}>
              <span>
                <MoreVertIcon
                  ref={anchorRef}
                  aria-controls={open ? 'menu-list-grow' : undefined}
                  aria-haspopup="true"
                  onClick={handleToggle}
                  fontSize="small"
                  style={{ display: 'inline-block', marginLeft: '34%' }}
                />
              </span>
            </div>

            <Popper
              open={open}
              anchorEl={anchorRef.current}
              role={undefined}
              transition
              className={classes.threedotsicon}
              disablePortal
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                  }}
                >
                  <Paper>
                    <ClickAwayListener onClickAway={handleClose}>
                      <MenuList
                        autoFocusItem={open}
                        id="menu-list-grow"
                        onKeyDown={handleListKeyDown}
                      >
                        <Link href="/doorcontrol" to={{ doors: mrdDoors }}>
                          <MenuItem onClick={handleClose}>View</MenuItem>
                        </Link>
                        <Link href="/doorcontrol">
                          <MenuItem onClick={handleClose}>Edit</MenuItem>
                        </Link>
                        <Link href="/doorcontrol">
                          <MenuItem onClick={handleClose}>Duplicate</MenuItem>
                        </Link>
                        <Link href="/doorcontrol">
                          <MenuItem onClick={handleClose}>Door Group</MenuItem>
                        </Link>
                        <Link href="/doorcontrol">
                          <MenuItem style={{ color: 'red' }} onClick={handleClose}>
                            Remove
                          </MenuItem>
                        </Link>
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <MUIDataTable
              data={formattedControlData()}
              columns={columns}
              options={tableOptions}
              className={classes.dataTable}
            />
          </Grid>
        </Grid>
      </Paper>
      {isExpandable && <DoorControl gridData={mrdDoors} />}
    </>
  );
};

export default DoorControlWidget;
